


























import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

@Component({
  computed: mapState({
    lang: (state: any) => state.partner.lang,
    weekdays() {
      moment.locale(this.lang);
      const days = moment.weekdaysShort();

      return days.slice(1).concat(days[0]);
    },
    monthName() {
      moment.locale(this.lang);

      return moment().month(this.month).format('MMMM');
    },
  }),
})
export default class CalendarMonth extends Vue {
  @Prop() public readonly year!: number;
  @Prop() public readonly month!: number;
  @Prop({ required: true }) public readonly variablePricingDates!: string[];

  // How many days in the month?
  public get daysInMonth() {
    return new Date(this.year, this.month + 1, 0).getDate();
  }

  // On which day of the week does the month start?
  public get firstDayOffset() {
    const day = new Date(this.year, this.month, 1).getDay();

    return (day + 6) % 7;
  }

  public getDateString(year: number, month: number, day: number): string {
    return `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  }

  private isVariablePricingDate(day: any) {
    const date = this.getDateString(this.year, this.month, day);
    return this.variablePricingDates.includes(date);
  }
}
